import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { Autocomplete, IconButton, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"
import { MuiTelInput } from "mui-tel-input"
import { formatPhoneNumber } from "../../Utils"

export default function PhoneModal({
    open,
    closeModal,
    title = "Text To",
    providedPhone = "",
    options_list = [], // [{ value: "a@a.com", name: "Preferred Contact" }]
    acceptEmpty = false,
}) {
    const [phone, setPhone] = React.useState(providedPhone)
    const updatePhone = (e, extra) => {
        if (extra.nationalNumber !== null && extra.nationalNumber !== undefined && extra.nationalNumber.length < 11) {
            setPhone(extra.nationalNumber)
            console.log(extra.nationalNumber)
        }
    }

    const submit = (e) => {
        e.preventDefault();
        closeModal && closeModal(phone)
    }

    const valid_phone = /^\d{10}$/.test(phone) || (acceptEmpty && phone.length === 0)

    React.useEffect(() => {
        if (open) {
            setPhone(providedPhone)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [providedPhone, open])

    return (
        <div>
            <Dialog
                open={open}
                onClose={() => closeModal && closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='sm'
                fullWidth
            >
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>{title}</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal && closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {!(options_list?.length > 0) &&
                            <MuiTelInput
                                margin="dense"
                                id="phone"
                                label="Phone"
                                type="tel"
                                inputMode="numeric"
                                variant="filled"
                                value={`+1 ${phone}`}
                                onChange={updatePhone}
                                onlyCountries={['US']}
                                defaultCountry="US"
                                forceCallingCode
                                disableDropdown
                                autoFocus={providedPhone.length < 1}
                                fullWidth
                            />
                        }
                        {options_list?.length > 0 &&
                            <Autocomplete
                                options={options_list}
                                value={`${phone}`}
                                isOptionEqualToValue={(option, value) => option.value === value}
                                getOptionLabel={(option) => option.value ?? option}
                                onChange={(event, newValue) => {
                                    setPhone(newValue?.value ?? '');
                                }}
                                freeSolo
                                size="small"
                                sx={{
                                    '& .MuiFilledInput-root': {
                                        pt: 0,
                                        pl: '12px'
                                    },
                                    '& .MuiFilledInput-root .MuiFilledInput-input': {
                                        pt: '25px',
                                        pr: '12px',
                                        pb: '8px',
                                        pl: '12px',
                                    }
                                }}
                                renderInput={(params) => {
                                    return (
                                        <div ref={params.InputProps.ref}>
                                            <MuiTelInput
                                                {...params.inputProps}
                                                ref={undefined}
                                                inputRef={params.inputProps.ref}
                                                className=""
                                                margin="dense"
                                                id="phone"
                                                label="Phone"
                                                type="tel"
                                                fullWidth
                                                variant="filled"
                                                value={`+1 ${phone}`}
                                                onChange={(event, extra) => {
                                                    if (extra.nationalNumber !== null && extra.nationalNumber !== undefined && extra.nationalNumber.length < 11) {
                                                        setPhone(extra.nationalNumber)
                                                    }
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                onlyCountries={['US']}
                                                defaultCountry="US"
                                                forceCallingCode
                                                disableDropdown
                                                autoFocus
                                            />
                                        </div>
                                    )
                                }}
                                renderOption={(props, option, { inputValue }) => {
                                    const { key, ...optionProps } = props;

                                    return (
                                        <li key={key} {...optionProps}>
                                            <div>
                                                <span>
                                                    {formatPhoneNumber(option.value)}
                                                </span>
                                                <br />
                                                <Typography sx={{ opacity: '50%', fontSize: '.7rem', pl: 1 }}>{option.name}</Typography>
                                            </div>
                                        </li>
                                    );
                                }}
                            />
                        }
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Button variant="contained" type="submit" disabled={!valid_phone}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}
